import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import useTable from "../../../../components/useTable";
//UI
import { DangerButton, PrimaryButton } from "../../../../ui/buttons/Button";
import { Input, SearchInput} from "../../../../ui/inputs/Input";

const headCells = [
  {
    id: "actividad",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Actividad",
    textAlign: "center",
  },
  {
    id: "codConcepto",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Cod. Concepto",
    textAlign: "center",
  },
  {
    id: "nombre",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nombre",
    textAlign: "center",
  },
];

export default function Vacaciones({ show, setShow, setTabla }) {
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    records,
    headCells,
    filterFn
  );

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="xl" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Actualizar Vacaciones</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 mb-2 p-2 d-flex flex-wrap">
        <div className="col-3 m-0 mb-2 p-0">
          <Input label = 'Id Vacaciones:' />
        </div>
        <div className="col-12 m-0 mb-2 p-0 d-flex gap-2">
          <div className="col-4 m-0 p-0">
            <SearchInput label = 'Cod. Integrante:' /> 
          </div>
          <Input label = 'Nombre:' />
        </div>
        <div className="col-3 m-0 mb-2 p-0">
          <Input label = 'Fec. Salida:' type = 'date'/>
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Días Disfrute:' />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Fec. Retorno:' type = 'date'/>
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Días por Año de Servicio:' />
        </div>
        <fieldset className="col-6 m-0 mb-2 p-2 d-flex gap-2 border-azul rounded">
          <legend className="m-0 w-auto float-none">
            Período que Corresponde (Años)
          </legend>
          <div className="col m-0 mb-2 p-0">
            <Input label = 'Fec. Inicio:' type = 'date'/>
          </div>
          <div className="col m-0 mb-2 p-0">
            <Input label = 'Fec. Fin:' type = 'date'/>
          </div>
        </fieldset>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Días Feriados:' />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Días Descanso:' />
        </div>
        <div className="col-11 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={index}></tr>
                ))}
            </tbody>
          </TblContainer>
        </div>
        <div className="col-1 m-0 mb-2 p-0 d-flex flex-column gap-2 align-items-center justify-content-center">
          <div className="col-auto m-0 p-0">
            <PrimaryButton icon="fa-plus m-0" />
          </div>
          <div className="col-auto m-0 mb-2 p-0">
            <DangerButton icon="fa-trash-alt m-0" />
          </div>
        </div>
        <div className="col-3 m-0 p-0">
          <Input label = 'Items:' />
        </div>
        <div className="col-3 m-0 p-0 pl-2">
          <Input label = 'Asignaciones:' />
        </div>
        <div className="col-3 m-0 p-0 pl-2">
          <Input label = 'Deducciones:' />
        </div>
        <div className="col-3 m-0 p-0 pl-2">
          <Input label = 'Total:' />
        </div>
      </Modal.Body>
    </Modal>
  );
}
